import React, { useState } from 'react';
import CustomDialog from 'components/CustomDialog/CustomDialog';
import { translate } from 'components/Translation';
import { BodyM } from 'components/Typography/Typography';
import Button from 'components/CustomButtons/Button';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/prepaidLoyalty/addNumbersDialogStyle';
import AddAnyNumber from './subcomponents/AddAnyNumber';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IAddNumbersDialog {
	isOpen: boolean;
	hideDialog: () => void;
	addNumbers: (numbers: string[]) => void;
}

const AddNumbersDialog = ({ isOpen, hideDialog, addNumbers }: IAddNumbersDialog) => {
	const classes = useStyles();
	const [numbers, setNumbers] = useState<string[]>([]);
	const [loading, setLoading] = useState<boolean>(false);

	const addNumbersDisabled = numbers.length <= 0;

	const clear = () => {
		setNumbers([]);
	};

	const onClick = () => {
		hideDialog();
		addNumbers(numbers);
		clear();
	};

	return (
		<CustomDialog
			header={translate('prepaid.loyalty.add.numbers')}
			isOpen={isOpen}
			hideDialog={hideDialog}
			loading={loading}
			dialogBody={
				<>
					<div className={classes.addNumbersDialogWrapper}>
						<BodyM disableMargin>{translate('prepaid.loyalty.add.numbers.description')}</BodyM>
						<AddAnyNumber
							numbers={numbers}
							setNumbers={setNumbers}
							loading={loading}
							setLoading={setLoading}
						/>
					</div>
					<div className={classes.buttonsWrapper}>
						<Button color="tertiary-light" onClick={hideDialog}>
							{translate('cancel')}
						</Button>
						<Button
							className={classes.addButton}
							color="primary-light"
							onClick={onClick}
							disabled={addNumbersDisabled}
						>
							{numbers.length ? translate('add.count', numbers.length) : translate('add')}
						</Button>
					</div>
				</>
			}
		/>
	);
};

export default AddNumbersDialog;
